import axios from '../../../axios'

// 列表
export const list = (data) => {
  return axios({
    url: '/basic/equipment/list',
    method: 'post',
    data
  })
}
// 获取筛选数据
export const getParams = (data) => {
  return axios({
    url: '/basic/equipment/getParams',
    method: 'post',
    data
  })
}
// 编辑
export const edit = (data) => {
  return axios({
    url: '/basic/equipment/edit',
    method: 'post',
    data
  })
}
// 保存
export const save = (data) => {
  return axios({
    url: '/basic/equipment/save',
    method: 'post',
    data
  })
}
// 查看
export const view = (data) => {
  return axios({
    url: '/basic/equipment/view',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/basic/equipment/delete',
    method: 'post',
    data
  })
}
// 获取一级设备列表
export const getLevel1List = (data) => {
  return axios({
    url: '/basic/equipment/getLevel1List',
    method: 'post',
    data
  })
}
// 获取二级设备列表
export const getLevel2List = (data) => {
  return axios({
    url: '/basic/equipment/getLevel2List',
    method: 'post',
    data
  })
}
// 获取环境列表
export const getUseEnvList = (data) => {
  return axios({
    url: '/basic/equipment/getUseEnvList',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/basic/equipment.js